export default {
  SettingBaseDataConfig: {
    channel: '系统渠道',
    logo: '系统标识',

    table: {
      channel: '系统渠道',
      logo: '系统标识',
      name: '平台应用名称',
      type: '平台应用类型',
      authorizeAddress: '授权地址',
      otherAddress: '其他地址',
      apiAddress: 'API服务地址',
      callbackAddress: '回调地址',
      AuthorizeAccount: '可授权账号',
      certificateTraffic: '证书流量',
      openPlatform: '开放平台地址',
      account: '账号',
      remark: '备注',
    },

    addAndEdit: {
      editValue: '编辑值集',
      addValue: '新增值集',
      msg: '应用信息',
      channel: '系统渠道',
      logo: '应用标识',
      applicationName: '平台应用名称',
      applicationType: '平台应用类型',
      authorize: '授权地址',
      otherAddress: '其他地址',
      api: 'API服务地址',
      callbackAddress: '回调地址',
      certificate: '证书流量',
      openPlatform: '开放平台地址',
      account: '账号',
      remark: '备注',
      callbackAddressText: '请输入回调地址',
      authorizeAccount: '可授权账号',
      applicationNameText: '请输入平台应用名称',
      applicationTypeText: '请输入平台应用类型',
      app_keyText: '请输入app_key',
      app_secretText: '请输入app_secret',
      channelText: '请选择系统渠道',
      systemText: '请输入系统标识',
      valueSet: '值集'
    }
  }
};
